/**
 * Utilities for working with URLs
 * @module
 */

/**
 * Returns the domain, possibly stripped of www, www2, ww3, etc.
 *
 * This was taken from publically available code found at:
 * http://w3guru.blogspot.com/2009/01/how-to-get-domain-name-from-url-using.html
 *
 * Examples:
 *   http://www.google.co.uk/?q=abc -> google.co.uk
 *   http://mysubdomain.mydomain.com/mypage.html -> mysubdomain.mydomain.com
 *
 * Note that in some theoretical cases, we may guess an incorrect domain:
 *   https://www.google.com:abc@example.com/abc -> google.com instead of example.com
 *
 * Ported from [user.getDomain@58fbbd4d2773e1b3b806ebd5191914914a4fe0de](https://github.com/optimizely/optimizely/blob/355acdd0edd085bc3c19163de55f909d2a239f8c/src/www/js/client/user.js#L67)
 *
 * @param {string} url
 * @param {boolean} preserveWWW - ensure url is not striped of www, www2 etc if it exists
 * @returns {string}
 */
exports.guessDomain = function(url:string, preserveWWW:boolean): string {
  if (!url) {
    return '';
  }
  try {
    if (preserveWWW) {
      return url.match(/:\/\/(.[^/]+)/)[1];
    }
    return url.match(/:\/\/(?:www[0-9]?\.)?(.[^/:]+)/)[1];
  }
  catch(err) {
    return '';
  }
};
